import { Component, OnInit, Inject } from '@angular/core';
import { Helper } from '../Helper';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.css']
})
export class PaymentPopupComponent implements OnInit {

  url1;
  currentUrl = ''
  options;
  framloaded=false;
  formopen=false;
  transactionId;
  constructor(
    public dialogRef: MatDialogRef<PaymentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public Helper: Helper,
    private dom: DomSanitizer,
  ) {
    let user = this.Helper.get("user");
    this.data = data;
    let finalAmount = 0;
    // this.currentUrl = window.location.href +'?pesaflow_success=1'
    this.currentUrl = window.location.origin + '/pesaflow-success'
  }


  ngOnInit(): void {
    this.Helper.makeRequest("paisa-flow", { amount: this.data.amount, redirect_url: this.currentUrl }, "post", { toast: false }).
      subscribe((data) => {
        this.options = data.data.options;
        this.transactionId = data.data.transaction_id
        setTimeout(()=>{

         (<HTMLFormElement>document.getElementById("frm")).submit();
          this.framloaded=false;
          this.formopen=true;
        },1000);
        // this.url1 = this.dom.bypassSecurityTrustResourceUrl(data.data.data);
      //   const win = window.open(
      //     data.data.data,
      //     // 'http://localhost:4200/pesaflow-success',
      //     'Secure Payment');
      //     window["receiveDataFromPopup"] = (data)=> {
      //       this.Helper.toast("Payment successful")
      //   };




      // const timer = setInterval(() => {
      //   if (win.closed) {
      //     clearInterval(timer);
      //     this.dialogRef.close();
      //   }
      // }, 500);
        // this.url1 = this.dom.bypassSecurityTrustResourceUrl(data.data.data);
        // this.url1 = this.dom.bypassSecurityTrustResourceUrl('https://test.pesaflow.com/api/invoice/checkout/PLZNGP?callback_url=https://lollapay.com/pesaflow/success');
      }, (err) => {
        this.Helper.toast("Error", "error")
      });



  }
   checkStatus(transaction_id) {
    this.Helper.makeRequest("paisa-flow/check-status", {transaction_id}, "post", { toast: false }).
    subscribe((data) => {
      if(data.status){
        this.dialogRef.close();
        this.Helper.toast("Payment successful")
      }
      else{
        // console.log('status false')
        setTimeout(()=>{
          this.checkStatus(transaction_id) ;
        },3000)
      }

    }, (err) => {

      setTimeout(()=>{
        this.checkStatus(transaction_id) ;
      },6000)
      this.Helper.toast("Error", "error")
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkUrl(frame) {
   this.framloaded=true;
   if(this.formopen && this.transactionId){
    this.checkStatus(this.transactionId);
   }

  }

}
